import { render } from "./TabContact.vue?vue&type=template&id=b4913758&ts=true"
import script from "./TabContact.vue?vue&type=script&lang=ts"
export * from "./TabContact.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__